import { KeyGenerator, toSlug } from "@superwall-me/schema";
import * as faker from "faker";
export const applicationWithoutIds = async ({ ...args } = {})=>{
    const { id, organizationId, creatorId, ...application } = await applicationFactory({
        ...args
    });
    return application;
};
export const applicationFactory = async (args)=>{
    const name = faker.company.companyName();
    return {
        name,
        slug: toSlug(name),
        // FitnessAI RC Key
        revenueCatPublicAPIKey: "ZFZFYcjSDvgFZQvIVZFxSnNgBOAloffe",
        appId: "1234",
        publicApiKey: await KeyGenerator.publicAPI(),
        appleUrlScheme: "fitnessai",
        featuresEnabled: "triggers,charts,users,notifications,localization,editor_v4",
        localizationProviderId: undefined,
        ...args
    };
};
